import { render, staticRenderFns } from "./AddOnDetailsContainer.vue?vue&type=template&id=cb5b7eee"
import script from "./AddOnDetailsContainer.vue?vue&type=script&lang=js"
export * from "./AddOnDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports